import requests from "./requests";
import { getArticleCardHref } from "utils/helpers";

export default {
	addBookmark,
	getBookmarks,
	getCerts,
	getEventProfile,
	getMultipass,
	getProfile,
	getUserCourses,
	getUserData,
	removeBookmark,
	updateEventProfile,
	updateProfile,
};

async function getUserData(id, token) {
	const userData = await requests.get(`/users/${id}`, { token, isExternal: false });
	return userData;
}

async function getBookmarks(user, type = "article", token) {
	const bookmarks = await requests.get(`/users/${user?.id}/bookmarks?type=${type}`, { token, isExternal: false });
	return bookmarks?.bookmarks || [];
}
async function addBookmark(user, article, token) {
	const contentType = article.sys.contentType;
	let type = "";
	let website_url = "";
	if (contentType === "basicArticle") {
		type = "article";
		website_url = getArticleCardHref(article.fields);
	}

	try {
		const data = {
			// title: article.fields.title,
			// description: article.fields.summary,
			// link: article.fields.canonicalUrl,
			// sublink: article.fields.canonicalUrl,
			cmsid: article.sys.id,
			type,
			website_url,
		};
		// 		{
		// 			"type": "string",
		//   "website_url": "string",
		//   "platform_url": "string",
		//   "cmsid": "string"
		// 		}

		const resp = await requests.post(
			`/users/${user["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/userid"]}/bookmarks`,
			data,
			{ token, isExternal: false }
		);

		return resp;
	} catch (err) {
		throw err;
	}
}

async function removeBookmark(user, bookmark, token) {
	try {
		const resp = await requests.delete(
			`/users/${user["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/userid"]}/bookmarks/${bookmark.id}`,
			{ token, isExternal: false }
		);

		return resp;
	} catch (err) {
		throw err;
	}
}

async function updateEventProfile(profile, token) {
	try {
		profile.requiresVisaForEventTravel = Boolean(profile.requiresVisaForEventTravel);
		profile.sponsorOptOut = Boolean(profile.sponsorOptOut);

		const data = {
			...profile,
			dietaryRestrictions: profile.dietaryRestrictions.join(";"),
		};

		await requests.put(`/users/profile/events`, data, { token });
	} catch (err) {
		throw err;
	}
}

async function updateProfile(profile, memberOnboardingComplete = false, token) {
	try {
		const data = {
			...profile,
			dietaryRestrictions: profile.dietaryRestrictions.join(";"),
		};

		await requests.put(`/users/profile?memberOnboardingComplete=${memberOnboardingComplete}`, data, { token });
	} catch (err) {
		throw err;
	}
}

async function getMultipass(url, token) {
	try {
		const multipassUrl = await requests.get(`/products/multipass?url=${url}`, { token });

		return multipassUrl;
	} catch (err) {
		console.error("Multipass error");
		return url;
	}
}

function handledDietaryRestrictions(profile) {
	//hacky code to handle either null or string 'diet1;diet2;diet'
	if (!profile.dietaryRestrictions) {
		profile.dietaryRestrictions = [];
	} else if (typeof profile.dietaryRestrictions === "string" || profile.dietaryRestrictions instanceof String) {
		profile.dietaryRestrictions = profile.dietaryRestrictions.split(";");
	}
}

async function getEventProfile(token) {
	const profile = await requests.get("/users/profile/events", { token });

	handledDietaryRestrictions(profile);
	return profile;
}

async function getProfile(token) {
	const profile = await requests.get("/users/profile", token);

	handledDietaryRestrictions(profile);
	return profile;
}

async function getCerts(token) {
	try {
		let apiResp = await requests.get(`/users/certifications`, { token });

		return apiResp;
	} catch (err) {
		console.error(err);
	}
}

async function getUserCourses(token) {
	try {
		let apiResp = await requests.get(`/courses/all`, { token });

		return apiResp;
	} catch (err) {
		console.error(err);
	}
}
